import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import { toast } from "react-toastify";
import userServiceApi from "../../api/userServiceApi";
import { getRequest } from "../../api/http";
import DeleteMembers from "./restore-members/deleted-members";
import Analytics from "./analytics/analytics";
import Help from "../login-form/Help";
import Home from "./home";

function PartnerOrganisation() {
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState("1");
  const [partnerData, setPartnerData] = useState({});
 

  useEffect(() => {
    sessionStorage.setItem("page", "home");
  }, []);

  window.addEventListener("popstate", () => {
    let page = sessionStorage.getItem("page");
    if (page === "home") {
      navigate('/partner-org')
    }
  });

  const getPartnerDetailsData = () => {
    getRequest(userServiceApi.partnerDetails())
      .then((response) => {
        if (response && response?.data) {
          console.log("PartnerDetails response----->", response?.data);
          sessionStorage.setItem("partnerType",   response?.data?.partnerType?.toLowerCase());
          sessionStorage.setItem("salesType",   response?.data?.salesType?.toLowerCase()); 
          setPartnerData({ ...response?.data });
        }
      })
      .catch((error) => {
        toast.error(error.error);
      });
  };

  useEffect(() => {
    getPartnerDetailsData();
  }, []);


  useEffect(() => {
    let tabVal = sessionStorage.getItem("activeKey");
    if (tabVal) {
      setActiveKey(tabVal);
    }
  }, []);

  const changeTab = (activeKey) => {
    sessionStorage.setItem("activeKey", activeKey);
    setActiveKey(activeKey);
  };

  return (
    <>
      <div className="tabContainer">
        <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={changeTab}>
          <Tabs.TabPane tab="Home" key={"1"}>
            <Home  partnerData = {partnerData}/>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Engagement" key={"2"}>
            <Analytics />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Restore Members" key={"3"}>
            <DeleteMembers
              setActiveKey={setActiveKey}
              organizationDeletionTime={partnerData.deletionThresholdDays}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Help" key={"4"}>
            <Help setActiveKey={setActiveKey}
            />
          </Tabs.TabPane>
        </Tabs>
      </div>

      {/* <div className="footerlogo">
        <div className="footer-content">
          <div className="footer-logo">
            <img
              src={require("../../assets/images/PoweredNew.png")}
              alt="connectsU logo"
              onClick={() => window.open("https://www.connectsu.co.uk/", "_blank")}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      </div> */}
    </>
  );
}

export default PartnerOrganisation;
